import type { IContractToRegistration } from './IContractToRegistration';
import { ResponsiblePropertyManager } from './ResponsiblePropertyManager';
import { EiendomToRegistration } from './EiendomToRegistration';
import { RegisteredContract } from './RegisteredContract';
import type { IRegisteredContractLine } from './IRegisteredContractLine';
import { DocumentInfo } from './DocumentInfo';

export class ContractToRegistration implements IContractToRegistration {
    public static parseObject(
        obj: IContractToRegistration,
    ): ContractToRegistration {
        try {
            return new ContractToRegistration(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Contract Registration object : ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public static empty() {
        return ContractToRegistration.parseObject({
            ansvarlig: ResponsiblePropertyManager.empty(),
            avsjekket: false,
            skalRegistreres: false,
            avsjekkKontraktlinjeIds: [],
            avsjekkLastUpdated: new Date(),
            bygg: EiendomToRegistration.empty(),
            byggNavn: '',
            byggNummer: '',
            hasStatusCode: false,
            kontrakter: [],
            kontraktRegistrertDato: new Date(),
            kontraktsNummer: '',
            kundeNavn: '',
            kundeNummer: '',
            navn: '',
            opprettetDato: '', //Vet ikke hva dette er.
            signertDato: '',
            statusKoder: [], //er i realiteten error-koder.
            underskrivere: [],
            dokumentId: '',
            filMetadata: DocumentInfo.empty(),
            prosessForvalterNavn: '',
            prosessForvalterId: '',
            prosessOekonomiNavn: '',
            prosessOekonomiId: '',
            prosessOekonomiQANavn: '',
            prosessOekonomiQAId: '',
            registreringStatus: '',
            registreringProsessId: '',
            registreringProsessType: 'Kontrakt',
            registreringsProsesser: [],
            sortingWeight: 0,
            lekoId: '',
        });
    }

    ansvarlig: IContractToRegistration['ansvarlig'];
    ansvarligEpost: string | null;
    ansvarligNavn: string | null;
    ansvarligOekonomiEpost: string | null;
    ansvarligOekonomiNavn: string | null;
    avsjekkKontraktlinjeIds: IContractToRegistration['avsjekkKontraktlinjeIds'];
    avsjekket: IContractToRegistration['avsjekket'];
    avsjekkLastUpdated: IContractToRegistration['avsjekkLastUpdated'];
    bygg: IContractToRegistration['bygg'];
    byggNavn: IContractToRegistration['byggNavn'];
    byggNummer: IContractToRegistration['byggNummer'];
    hasStatusCode: IContractToRegistration['hasStatusCode'];
    kontrakter: IContractToRegistration['kontrakter'];
    kontraktRegistrertDato: IContractToRegistration['kontraktRegistrertDato'];
    kontraktsNummer: IContractToRegistration['kontraktsNummer'];
    kundeNavn: IContractToRegistration['kundeNavn'];
    kundeNummer: IContractToRegistration['kundeNummer'];
    navn: IContractToRegistration['navn'];
    opprettetDato: IContractToRegistration['opprettetDato'];
    signertDato: IContractToRegistration['signertDato'];
    statusKoder: IContractToRegistration['statusKoder'];
    underskrivere: IContractToRegistration['underskrivere'];
    dokumentId: IContractToRegistration['dokumentId'];
    filMetadata: IContractToRegistration['filMetadata'];
    skalRegistreres: IContractToRegistration['skalRegistreres'];
    prosessForvalterNavn: IContractToRegistration['prosessForvalterNavn'];
    prosessForvalterId: IContractToRegistration['prosessForvalterId'];
    prosessOekonomiNavn: IContractToRegistration['prosessOekonomiNavn'];
    prosessOekonomiId: IContractToRegistration['prosessOekonomiId'];
    prosessOekonomiQANavn: IContractToRegistration['prosessOekonomiQANavn'];
    prosessOekonomiQAId: IContractToRegistration['prosessOekonomiQAId'];
    registreringStatus: IContractToRegistration['registreringStatus'];
    registreringProsessId: IContractToRegistration['registreringProsessId'];
    registreringProsessType: IContractToRegistration['registreringProsessType'];
    registreringsProsesser: IContractToRegistration['registreringsProsesser'];
    sortingWeight: number;
    lekoId: IContractToRegistration['lekoId'];

    constructor(props: IContractToRegistration) {
        Object.assign(this, props);
        this.ansvarligEpost = props.ansvarlig?.epost || '';
        this.ansvarligNavn = props.ansvarlig?.navn || '';
        this.ansvarligOekonomiEpost = props.bygg?.oekonomiEPost || '';
        this.ansvarligOekonomiNavn = props.bygg?.oekonomiNavn || '';
        this.avsjekket = props.avsjekket;
        this.byggNavn = props.bygg?.navn || '';
        this.hasStatusCode = !!props.statusKoder.length;
        this.signertDato = props.signertDato;
        this.kontrakter =
            props?.kontrakter?.length !== 0
                ? RegisteredContract.parseArray(props.kontrakter || [])
                : [];
        this.filMetadata = props.filMetadata;
        this.skalRegistreres = props.skalRegistreres;
        this.prosessForvalterNavn = props.prosessForvalterNavn;
        this.prosessForvalterId = props.prosessForvalterId;
        this.prosessOekonomiId = props.prosessOekonomiId;
        this.prosessOekonomiNavn = props.prosessOekonomiNavn;
        this.prosessOekonomiQAId = props.prosessOekonomiQAId;
        this.prosessOekonomiQANavn = props.prosessOekonomiQANavn;
        this.registreringStatus = props.registreringStatus;
        this.sortingWeight = this.avsjekket ? 0 : 1;
        this.lekoId = props.lekoId || '';
    }

    public getLinjer(): Array<IRegisteredContractLine> {
        const result: Array<IRegisteredContractLine> = [];

        this.kontrakter?.forEach((element) => {
            element.linjer.forEach((el) => {
                result.push(el);
            });
        });

        return result;
    }
}
